module.exports = __webpack_public_path__ + "img/our_banner@2x.e8259e26.png";